import EssenceAnimatedButton from '../../components/essence/button/animated-button';
import { Participant } from '../../shared/models/participant';
import { useNavigate } from 'react-router-dom';
import ExpenseSummaryList from './expense-summary-list';
import { ExpenseSummary as ExpenseSummaryItem } from '../../shared/models/expense-summary';
import { useState, useEffect } from 'react';
import accountService from '../../shared/services/account-service';
import { useExpenseContext } from '../../contexts/expense/expense-context';
import { Expense } from '../../shared/models/expense';

interface Props {
	expensesSummary: ExpenseSummaryItem[];
	participants: Participant[];
	circleId: string;
}

export default function ExpenseSummary({ expensesSummary, participants, circleId }: Props) {
	const [loggedInUserId, setLoggedInUserId] = useState('');
	const { setExpense } = useExpenseContext();

	useEffect(() => {
		const account = accountService.getAccount();
		if (account) {
			setLoggedInUserId(account.id);
		}
	}, []);

	const navigate = useNavigate();

	const goToSettleUp = () => {
		const expense: Expense = {
			id: '',
			...expensesSummary[0],
			creditors: expensesSummary.map(x => ({
				id: x.debtorId,
				amount: x.amount,
				currency: x.currency,
				circleId: circleId,
				name: x.debtorName,
			})),
			debtors: expensesSummary.map(x => ({
				id: x.creditorId,
				amount: x.amount,
				currency: x.currency,
				circleId: circleId,
				name: x.creditorName,
			})),
			dateTime: new Date(),
			circleId: circleId,
			description: 'Settlement',
			isSettlement: true,
			createdById: loggedInUserId,
		};
		setExpense(expense);
		navigate(`/secure/circles/${circleId}/add-settlement/payee`);
	};

	return (
		<div className="mb-6 gap-20 items-center">
			{expensesSummary.map(summary => (
				<ExpenseSummaryList
					key={summary.creditorId}
					expenseSummary={summary}
					loggedInUserId={loggedInUserId}
					participants={participants}
				/>
			))}
			<EssenceAnimatedButton name="settle up" onClick={goToSettleUp} />
		</div>
	);
}
